import { Tag } from 'primereact/tag';
import { useTranslation } from 'react-i18next';

import { CertificatePermissionReviewStatus } from '../../../../../../../../shared/interfaces/ICertificate';
import styles from './CertificatePermissionStatus.module.css';

type CertificatePermissionStatusProps = {
  status: CertificatePermissionReviewStatus;
};

const CertificatePermissionStatus = ({ status }: CertificatePermissionStatusProps) => {
  const { t } = useTranslation();

  const statusConfigMap: Record<
    CertificatePermissionReviewStatus,
    { className: string; text: string } | undefined
  > = {
    [CertificatePermissionReviewStatus.ACCEPTED]: {
      className: styles['accepted-tag'],
      text: t('certificateDetailsPage.tabs.permissionsTab.statuses.accepted'),
    },

    [CertificatePermissionReviewStatus.REJECTED]: {
      className: styles['rejected-tag'],
      text: t('certificateDetailsPage.tabs.permissionsTab.statuses.rejected'),
    },

    [CertificatePermissionReviewStatus.RECEIVED]: {
      className: styles['pending-tag'],
      text: t('certificateDetailsPage.tabs.permissionsTab.statuses.pending'),
    },
  };

  const config = statusConfigMap[status];

  if (!config) {
    return null;
  }

  return (
    <Tag rounded className={`text-sm font-medium px-2 py-1 ${config.className} w-fit`}>
      {config.text}
    </Tag>
  );
};

export default CertificatePermissionStatus;
